export const generatedByUserCategoryId = '6b074474-c747-4176-bf7b-ba296a49e1ec';
// Elements COMPONENT_DEFINITION category
export const elementsCategoryId = '2487e1a0-3a43-41c5-8e0a-e9265c854d83';

export const SHOWROOM_CATEGORY_IDS = [
  '181047c5-9ec5-412e-95fd-eaa09271f4ea',
  '2487e1a0-3a43-41c5-8e0a-e9265c854d83',
];
